import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

/**
 *   Import Fontawesome Icons
 *   For adding new icons -> import { faName } from '@fortawesome/pro-SIZE-svg-icons'
 *   Add to the library.add();
 *   ---
 *   In the file where you want the icon -> import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 *   Then in render -> <FontAwesomeIcon icon={['abbreviationSize', 'faName']}/>
 *   ---
 *   When adding icons from same SIZE, please import in same import line
 *   ---
 *   If the same icon needs to be added from multiple SIZES -> import { faName as abbreviationSizeFaName }
 *   ---
 *   Abbreviations:
 *   far = fontawesome pro regular
 *   fas = fontawesome pro solid
 *   fab = fontawesome pro brands
 *   fal = fontawesome pro light
 *   ---
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleNotch as falFaCircleNotch } from '@fortawesome/pro-light-svg-icons';
import { faStepBackward as farStepBackward } from '@fortawesome/pro-regular-svg-icons';
import {
    faStepBackward as fasStepBackward,
    faStepForward as fasStepForward,
    faPlay as fasPlay,
    faStop as fasStop,
    faVolume as fasVolume,
} from '@fortawesome/pro-solid-svg-icons';

import './styles/App.scss';
import App from 'components/App';

library.add(
    // fa light
    falFaCircleNotch,
    // fa regular
    farStepBackward,
    // fa solid
    fasStepBackward,
    fasStepForward,
    fasPlay,
    fasVolume,
    fasStop
);

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
} else {
    Sentry.init({
        dsn:
            'https://a88adc9dae1d4d0c8993238bbaffc81e@o236432.ingest.sentry.io/6006655',
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.05,
        release: process.env.MIX_SENTRY_GIT_HASH,
        environment: process.env.MIX_APP_ENV,
    });
}

ReactDOM.render(<App />, document.getElementById('root'));
